import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {createSearchParams, generatePath, Link, useNavigate, useParams, useSearchParams} from "react-router-dom";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {
  addLessonAction,
  getOneLessonAction,
  materialResultSendAction,
  taskResultSendAction, testBegin
} from "../../../store/pages/plans/actions";
import {RootState} from "../../../store";
import {selectStore} from "../../../store/selector";
import {MyBreadcrumb, MyButton, MyModalForm, MyText} from "../../../components";
import {Alert, Card, Col, Flex, Form, Input, List, Modal, Row, Spin, TabsProps} from "antd";
import {StyledInfoContainer} from "../../Plans/[ctpId]/index.styles";
import {StyledTabs} from "../../Plans/[ctpId]/[lessonId]/index.styles";
import {FORM_SECTION_TYPES, FORM_SECTION_INNER_TYPE, JOURNAL_QUERY_PARAMS, FORM_FORM_TYPE, ROUTE_PATH} from "../../../constants";
import {getFormAction, setFormAction} from "../../../store/common/actions";
import {DefaultTokenTheme} from "../../../assets/themes/defaultTheme";
import {EditOutlined, PaperClipOutlined} from "@ant-design/icons";
import dayjs from "dayjs";
import {Color} from "../../../themes";
import {StyledAlert} from "./index.styles";
import {ApplicationDownloadIcon} from "../../../assets";

interface IInitialState {
  visible: boolean,
  item?: any
}


const FORM_NAME = {
  PLANS_TASKS_ADD: 'PLANS_TASKS_ADD',
  PLANS_MATERIAL_UPDATE: 'PLANS_MATERIAL_UPDATE'
}

const initialState: IInitialState = {
  visible: false,
  item: {}
}

const modalInitialState = {
  [FORM_NAME.PLANS_TASKS_ADD]: initialState,
  [FORM_NAME.PLANS_MATERIAL_UPDATE]: initialState,
}

export const ScheduleStudentPlan = () => {
  const {t} = useTranslation("common")
  const {lessonId} = useParams()

  const dispatch = useDispatch()
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const {
    common: {form: formState},
    plans: {lessons: lessonState, oneCtp: oneCtpState, oneLesson: oneLessonState, oneTest: oneTestState, testResult: testResultState}
  }: RootState = useSelector(selectStore)

  const [currentTab, setCurrentTab] = useState(FORM_FORM_TYPE.MATERIALS)
  const [formModalData, setFormModalData] = useState(modalInitialState)

  const [formTasksAdd] = Form.useForm()
  const [formMaterialUpdate] = Form.useForm()

  const [formPassword] = Form.useForm()


  const handleTabChange = useCallback((key: any) => {
    setCurrentTab(key)
  }, [])

  useEffect(() => {
    dispatch(getOneLessonAction({lesson_id: lessonId}))
  }, []);

  const materialAlertType = {
    0: 'error',
    1: 'success'
  }

  const handleOpenLink = (url:string) => {
    window.open(url, "_blank")
  }

  const renderInnerItem = (item: any) => {
    return (
      <Row align='middle' gutter={6}>
        <Col span={7}>
          <MyText color={'var(--c-subtitle)'} weight={500}>
            {item.label}:
          </MyText>
        </Col>

        <Col span={17}>
          <MyText>
            <div dangerouslySetInnerHTML={{ __html: item?.value }} />
          </MyText>
        </Col>
      </Row>
    )
  }

  const testsContent = useCallback((item: any) => {
    let render = {
      '0': (
        <Row  gutter={[10, 10]} justify='space-between' align='middle'>
          <Col>
            <MyButton onClick={() => handleClickTests(item)} disabled={item.is_proctoring || !item.isAdd}>
              {t('passTest')}
            </MyButton>
          </Col>

          <Col>
            <Alert type='error' message={item?.resultByStudent?.stateLabel}/>
          </Col>
        </Row>
      ),
      '1': (
        <Row  gutter={[10, 10]} justify='space-between' align='middle'>
          <Col>
            <Row gutter={[10, 10]} justify='space-between' align='middle'>
              <Col span={24}>
                <MyText size={20} weight={500} color='rgba(28, 28, 30, 1)'>
                  {t('testResult')}
                </MyText>
              </Col>


              <Col span={24}>
                <Row gutter={[10, 10]}>
                  <Col span={12}>
                    <MyText>
                      {t('passDate')}: {dayjs(item?.resultByStudent?.finished).format('DD.MM.YYYY HH:mm:ss')}
                    </MyText>
                  </Col>

                  <Col span={12}>
                    <MyText>
                      {t('numberOfCorrect')}: {item?.resultByStudent?.correct_answers}
                    </MyText>
                  </Col>

                  <Col span={12}>
                    <MyText>
                      {t('result')}: {item?.resultByStudent?.result}
                    </MyText>
                  </Col>

                  <Col span={24}>
                    {
                      item?.is_repeatable &&
                      <MyButton onClick={() => handleClickTests(item)} disabled={item.is_proctoring || !item.isAdd}>
                        {t('passTest')}
                      </MyButton>
                    }
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>

          <Col>
            <Alert type='success' message={item?.resultByStudent?.stateLabel}/>
          </Col>
        </Row>
      ) ,
    }

    return (
      <Col span={24}>
        <Row gutter={[16, 16]}>
          {
            item?.view?.map((inner: any, innerIndex: number) => (
              <Col key={innerIndex} span={24}>
                {renderInnerItem(inner)}
              </Col>
            ))
          }
          {item.is_proctoring ? (
            <Col span={24}>
              <StyledAlert type="info"  showIcon message={
                <Row justify="space-between">
                  <MyButton type="text" onClick={() => handleOpenLink("https://object.pscloud.io/ffa/skuggcke/igguggim/wascsoug/7f9650956898a4860c7fba4ce7d9bca24a3c74ac.exe")}>
                    <MyText color="#1F3C88">Скачать приложение прокторинга</MyText>
                  </MyButton>
                  <MyButton type="text" onClick={() => handleOpenLink("https://ffa.object.pscloud.io/skuggcke/igguggim/wascsoug/d6b3930ef394a294c61ac75c4a43551468739ff1.docx")}>
                    <Row align="middle">
                      <MyText color="#1F3C88" style={{marginRight: 12}}>Инструкция для скачивания </MyText>
                      <ApplicationDownloadIcon/>
                    </Row>
                  </MyButton>
                </Row>
              }/>
            </Col>
          ) : null}
          <Col span={24}>
            <Card styles={{
              body: {
                padding: 12, background: '#FAFAFA'
              }
            }}>
              {
                item?.resultByStudent ?
                  // @ts-ignore
                  render[item?.resultByStudent?.state]
                  :
                  <MyButton onClick={() => handleClickTests(item)} disabled={item.is_proctoring || !item.isAdd}>
                    {t('passTest')}
                  </MyButton>
              }


            </Card>
          </Col>
        </Row>
      </Col>
    )

  }, [])

  const handleClickTasks = useCallback((item: any) => {
    const api = 'sdot_add_task_result_v1'
    const section_type = FORM_SECTION_TYPES.PLANS
    const section_inner_type = FORM_FORM_TYPE.TASKS
    const form_type = FORM_SECTION_INNER_TYPE.ADD


    dispatch(getFormAction({
      api: api,
      section_type: section_type,
      section_inner_type: section_inner_type,
      form_type: form_type,
    }))


    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_TASKS_ADD]: {...prevState[FORM_NAME.PLANS_TASKS_ADD], visible: true, item: item}
    }))
  }, [])

  const handleFormModalClose = () => {
    setFormModalData(modalInitialState)
  }

  const handleModalTasksAddSave = (values: any) => {
    const main: any = formState[FORM_SECTION_TYPES.PLANS][FORM_FORM_TYPE.TASKS][FORM_SECTION_INNER_TYPE.ADD].data[0]
    const state: any = formModalData[FORM_NAME.PLANS_TASKS_ADD]

    let body = {
      ...values,
      lesson_id: lessonId,
      task_id: state?.item?.id
    }

    dispatch(setFormAction({
      method: main?.method,
      path: main?.action,
      fields: body,
      action: taskResultSendAction
    }))

    setFormModalData(modalInitialState)
  }

  const handleModalMaterialUpdateSave = (values: any) => {
    const main: any = formState[FORM_SECTION_TYPES.PLANS][FORM_FORM_TYPE.MATERIALS][FORM_SECTION_INNER_TYPE.UPDATE].data[0]
    const state: any = formModalData[FORM_NAME.PLANS_MATERIAL_UPDATE]

    let body = {
      lesson_id: lessonId,
      material_id: state?.item?.id,
      ...values,
    }

    console.log('state', state)

    dispatch(setFormAction({
      method: main?.method,
      path: main?.action,
      fields: body,
      action: materialResultSendAction
    }))

    setFormModalData(modalInitialState)
  }


  const handleClickTests = (item: any) => {
    if (item.is_password_protected) {
      Modal.confirm({
        title: t('enterTestPassword'),
        okText: t('continue'),
        cancelText: t('cancel'),
        okType: 'primary',
        icon: null,
        centered: true,
        content: (
          <Form form={formPassword}>
            <Form.Item name={'password'}>
              <Input/>
            </Form.Item>
          </Form>
        ),
        onOk: () => {
          dispatch(testBegin({
            test_id: item.id,
            lesson_id: lessonId,
            onSuccess: () => handleNavigate(ROUTE_PATH.STUDENTS_SCHEDULE_PLAN_TEST, item.id),
            test_password: formPassword.getFieldsValue().password
          }))
        },
        onCancel: () => {

        }
      })
    }
    else if (!item.is_password_protected) {
      dispatch(testBegin({
        test_id: item.id,
        lesson_id: lessonId,
        onSuccess: () => handleNavigate(ROUTE_PATH.STUDENTS_SCHEDULE_PLAN_TEST, item.id),
        test_password: '***'
      }))
    } else {
      handleNavigate(ROUTE_PATH.STUDENTS_SCHEDULE_PLAN_TEST, item.id)
    }
  }

  const handleClickMaterial = useCallback((item: any) => {
    const api = item.resultByStudent?.form
    const section_type = FORM_SECTION_TYPES.PLANS
    const section_inner_type = FORM_FORM_TYPE.MATERIALS
    const form_type = FORM_SECTION_INNER_TYPE.UPDATE


    dispatch(getFormAction({
      api: api,
      section_type: section_type,
      section_inner_type: section_inner_type,
      form_type: form_type,
    }))


    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_MATERIAL_UPDATE]: {...prevState[FORM_NAME.PLANS_MATERIAL_UPDATE], visible: true, item: item}
    }))
  }, [])

  const renderTaskComponent = (file: any, index: any) => {
    return (
      <Row gutter={[16, 16]} align='middle' key={index}>
        <Col>
          <Flex justify='center' align='center' style={{
            width: 48,
            height: 48,
            borderRadius: 8,
            background: '#F2F2F7'
          }}>
            <PaperClipOutlined style={{fontSize: 20}}/>
          </Flex>
        </Col>
        <Col span={20}>
          <Row gutter={[8, 8]} align='middle'>
            <Col span={24}>
              <MyText color='#8E8E8E' size={12} weight={500}>
                {t('file')}
              </MyText>
            </Col>
            <Col span={24}>
              <Link to={file}>
                <MyText color={Color.link}>
                  {file.split('/')?.[file.split('/')?.length - 1]}
                </MyText>
              </Link>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

  const taskInnerContent = (current: any) => {
    switch (current?.resultByStudent?.state) {
      case 0:
        return (
          <Alert message={t('notDone')} type="error" showIcon/>
        )
      case 5:
        return (
          <Alert message={t('underReview')} type="warning" showIcon/>
        )
      case 6:
        return (
          <Alert message={t('verified')} type="success" showIcon/>
        )
    }
  }

  const markPlanFormTypesLabel = {
    [FORM_FORM_TYPE.TASKS]: t('rateTasks'),
    [FORM_FORM_TYPE.TESTS]: t('rateTests'),
  }


  let currentPlanFormSdotTypes = {
    [FORM_FORM_TYPE.MATERIALS]: oneLessonState.data?.['materials-grade'],
    [FORM_FORM_TYPE.TASKS]: oneLessonState.data?.['tasks-grade'],
    [FORM_FORM_TYPE.TESTS]: oneLessonState.data?.['tests-grade'],
  }

  const innerRender = useMemo(() => {
    const main = oneLessonState.data ? oneLessonState.data?.[currentTab] : []
    return (
      <List
        dataSource={main}
        rowKey={(record: any) => record.id}
        style={{width: '100%'}}
        loading={oneLessonState.loading}
        renderItem={(item: any) => {
          switch (currentTab) {
            case FORM_FORM_TYPE.MATERIALS:
              return (
                <List.Item style={{padding: 16}}>
                  <Row style={{width: '100%'}} gutter={[8, 16]} align='top'>
                    <Col span={20}>
                      <Row>
                        {
                          item.view?.map((inner: any, index: any) => (
                            <Col key={index} span={24}>
                              {renderInnerItem(inner)}
                            </Col>
                          ))
                        }
                      </Row>
                    </Col>
                    {
                      item?.resultByStudent &&
                      <Col span={4}>
                        <Row align='middle' gutter={8} justify='space-between'>
                          <Col>
                            {/*// @ts-ignore*/}
                            <Alert message={item?.resultByStudent?.stateLabel} type={materialAlertType[item?.resultByStudent?.state]} showIcon/>
                          </Col>

                          <Col>
                            <MyButton type='text' icon={<EditOutlined/>} onClick={() => handleClickMaterial(item)}/>
                          </Col>
                        </Row>
                      </Col>
                    }
                  </Row>
                </List.Item>
              )
            case FORM_FORM_TYPE.TASKS:
              return (
                <List.Item style={{padding: 16}}>
                  <Row style={{width: '100%'}} gutter={[8, 16]}>
                    {
                      item.view?.map((inner: any, index: any) => (
                        <Col key={index} span={24}>
                          {renderInnerItem(inner)}
                        </Col>
                      ))
                    }

                    <Col span={24}>
                      {
                        item?.resultByStudent?.id ?
                          <Card styles={{
                            body: {
                              padding: 12, background: '#FAFAFA'
                            }
                          }}>
                            <Row gutter={[10, 10]} justify='space-between' align='middle'>
                              <Col span={20}>
                                <Row gutter={[10, 10]}>
                                  <Col span={24}>
                                    <MyText size={20} weight={500} color='rgba(28, 28, 30, 1)'>
                                      {t('myAnswer')}
                                    </MyText>
                                  </Col>

                                  {
                                    item?.resultByStudent?.answer &&
                                    <Col span={24}>
                                      <MyText>
                                        {item?.resultByStudent?.answer}
                                      </MyText>
                                    </Col>
                                  }

                                  {
                                    item?.resultByStudent?.files &&
                                    <Col span={24}>
                                      {
                                        Array.isArray(item?.resultByStudent?.files) ? item?.resultByStudent?.files?.map((file: any, index: any) => (
                                            file && renderTaskComponent(file, index)
                                          ))
                                          : renderTaskComponent(item?.resultByStudent?.files, 'indexFileResultByStudent')
                                      }
                                    </Col>
                                  }
                                </Row>
                              </Col>
                              {
                                item?.resultByStudent?.id &&
                                <Col span={4}>
                                  {taskInnerContent(item)}
                                </Col>
                              }
                            </Row>
                          </Card>
                          :
                          <MyButton onClick={() => handleClickTasks(item)}>
                            {t('setTasks')}
                          </MyButton>
                      }
                    </Col>
                  </Row>
                </List.Item>
              )
            case FORM_FORM_TYPE.TESTS:
              return (
                <List.Item style={{padding: 16}}>
                  <Row style={{width: '100%'}} gutter={[8, 16]}>
                    {testsContent(item)}
                  </Row>
                </List.Item>
              )
            default:
              return false
          }
        }}
      />
    )
  }, [oneLessonState, currentTab])

  const tabItems: TabsProps["items"] = [
    {
      key: FORM_FORM_TYPE.MATERIALS,
      label: t('materials'),
      children: innerRender
    },
    {
      key: FORM_FORM_TYPE.TASKS,
      label: t('tasks'),
      children: innerRender
    },
    {
      key: FORM_FORM_TYPE.TESTS,
      label: t('tests'),
      children: innerRender
    },
    oneLessonState?.data?.homework && {
      key: FORM_FORM_TYPE.HOME_WORK,
      label: t('homeWorks'),
      disabled: !oneLessonState?.data?.homework,
      children: (
        <Flex style={{
          padding: 16
        }}>
          <MyText>
            {oneLessonState?.data?.homework}
          </MyText>
        </Flex>
      )
    }
  ]

  const handleNavigate = (url: any, testId: any) => {
    const path = {
      // @ts-ignore
      pathname: generatePath(url, {lessonId: lessonId, testId: testId}),
    }
    navigate(path)
  }

  return (
    <>
      <MyBreadcrumb title={t('back')} isBack/>

      <Row justify='center'>
        <Col span={20}>
          <StyledInfoContainer>
            <Spin spinning={oneLessonState.loading || testResultState.loading}>
              <Row style={{borderBottom: '1px solid #E8E8E8', padding: 24}}>
                <Col>
                  <h1>{oneLessonState.data?.header}</h1>
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{padding: 24}}>
                {
                  oneLessonState.data?.view?.filter((item: any) => item.template !== 'accordion')?.map((item: any) => (
                    item.value &&
                    <Col span={12} key={item.label}>
                      <MyText>
                        {item.label} : {item.value}
                      </MyText>
                    </Col>
                  ))
                }
              </Row>
            </Spin>
          </StyledInfoContainer>

          <StyledInfoContainer>
            <Spin spinning={testResultState.loading}>
              <StyledTabs activeKey={currentTab} items={tabItems} onChange={handleTabChange}/>
            </Spin>
          </StyledInfoContainer>

          {
            markPlanFormTypesLabel[currentTab] &&
            <StyledInfoContainer>
              <Card loading={oneLessonState.loading}>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <MyText size={18} weight={500}>
                      {markPlanFormTypesLabel[currentTab]}
                    </MyText>
                  </Col>

                  <Col span={24}>
                    <Row gutter={16} align='middle'>
                      <Col>
                        <MyText weight={500} size={18}>
                          {currentPlanFormSdotTypes?.[currentTab]?.percent}
                        </MyText>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </StyledInfoContainer>
          }
        </Col>
      </Row>

      <MyModalForm
        formName={FORM_NAME.PLANS_TASKS_ADD}
        form={formTasksAdd}
        title={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.TASKS]?.[FORM_SECTION_INNER_TYPE.ADD]?.data[0]?.title}
        visible={formModalData[FORM_NAME.PLANS_TASKS_ADD].visible}
        state={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.TASKS]?.[FORM_SECTION_INNER_TYPE.ADD]}
        onCancel={handleFormModalClose}
        onFinish={handleModalTasksAddSave}
      />

      <MyModalForm
        formName={FORM_NAME.PLANS_MATERIAL_UPDATE}
        form={formMaterialUpdate}
        title={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.MATERIALS]?.[FORM_SECTION_INNER_TYPE.UPDATE]?.data[0]?.title}
        visible={formModalData[FORM_NAME.PLANS_MATERIAL_UPDATE].visible}
        state={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.MATERIALS]?.[FORM_SECTION_INNER_TYPE.UPDATE]}
        onCancel={handleFormModalClose}
        onFinish={handleModalMaterialUpdateSave}
      />

    </>
  )
}
